module.exports = __webpack_public_path__ + "img/tile-inf2.4b4d6903.jpg";